import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=131b26e4&scoped=true"
import script from "./NoContent.vue?vue&type=script&lang=js"
export * from "./NoContent.vue?vue&type=script&lang=js"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=131b26e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b26e4",
  null
  
)

export default component.exports